(function initForms( $ ){
    var forms = $( 'form._validate' );

    forms.each( function( index, form ){
        var validator = $( form ).validate( {
            highlight: function( element ){
                $( element ).closest( '.has-feedback' ).addClass( 'has-error' );
            },
            unhighlight: function( element ){
                $( element ).closest( '.has-feedback' ).removeClass( 'has-error' );
            },
            errorElement: 'span',
            errorClass: 'help-block',
            errorPlacement: function( error, element ){
                // Input Groups
                if( element.parent( '.input-group' ).length ){
                    error.insertAfter( element.parent() );
                }
                // Checkboxes
                else if ( element.parents( '.checkbox' ).length ) {
                    error.appendTo( element.parents( '.checkbox' ) );
                }
                else{
                    error.insertAfter( element );
                }
            },
            submitHandler: function( form ){
                var stopSubmit = $( form ).attr( 'data-stop-submit' );

                if( stopSubmit !== 'data-stop-submit' && stopSubmit !== '1' && stopSubmit !== 'true' ){
                    form.submit();
                }
            }
        } );
    } );
})( $ );
